import { useState } from "react";
import { track } from "../lib/analytics.ts";

/** Where feedback emails go. Forward it to the project inbox with Cloudflare Email Routing. */
export const FEEDBACK_EMAIL = "feedback@enoughwise.com";

const BODY = [
  "Which tab were you using? (Corpus calculator / Plan your spending / USD → INR transfer)",
  "",
  "What worked, what didn't, or what would you add?",
  "",
  "",
  "(Please don't include account numbers or other private details.)",
].join("\n");

const MAILTO = `mailto:${FEEDBACK_EMAIL}?subject=${encodeURIComponent("Enoughwise feedback")}&body=${encodeURIComponent(BODY)}`;

/**
 * Two ways to give feedback without a server: a one-click vote, counted
 * anonymously through the existing analytics, and an email the person sends
 * from their own mail app.
 */
export function Feedback() {
  const [vote, setVote] = useState<"yes" | "no" | null>(null);
  const [copied, setCopied] = useState(false);

  const cast = (v: "yes" | "no") => {
    if (vote) return;
    setVote(v);
    track("feedback-vote", { vote: v });
  };

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(FEEDBACK_EMAIL);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  };

  return (
    <section className="feedback" id="feedback" aria-labelledby="feedback-title">
      <h2 id="feedback-title">Help improve Enoughwise</h2>

      <div className="feedback-row">
        <span className="feedback-q">Was this useful?</span>
        {vote ? (
          <span className="feedback-thanks" role="status">
            Thanks — {vote === "yes" ? "glad it helped." : "tell us what was missing below."}
          </span>
        ) : (
          <span className="feedback-votes">
            <button type="button" className="secondary-btn" onClick={() => cast("yes")}>Yes</button>
            <button type="button" className="secondary-btn" onClick={() => cast("no")}>No</button>
          </span>
        )}
      </div>

      <div className="feedback-row">
        <span className="feedback-q">Suggestions, errors or questions</span>
        <span className="feedback-votes">
          <a className="button-link" href={MAILTO} onClick={() => track("feedback-email")}>
            Email feedback
          </a>
          <button type="button" className="link" onClick={copy}>
            {copied ? "Address copied" : `Copy ${FEEDBACK_EMAIL}`}
          </button>
        </span>
      </div>

      <p className="feedback-note">
        Votes are counted anonymously, with nothing else attached. Emails come from your own mail
        app; please leave out account numbers and other private details.
      </p>
    </section>
  );
}
